import ContratTemplateTitre from '@/generated/controls/contratTemplate/ContratTemplateTitre.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: ContratTemplateTitre
})
